import styled from "styled-components";
import { Link } from "react-router-dom";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { mediaMax } from "components/designV2/breakpoints";
import { Duration, Easing } from "components/designV2/motion";

export const Container = styled.nav`
  align-items: center;
  background-color: ${ColorV2.White};
  border-radius: 24px;
  display: flex;
  flex: 1;
  height: 64px;
  min-width: 0;
  padding: 0 clamp(4px, 2vw, 24px);
  overflow: hidden;
  position: relative;
`;

export const Logo = styled.img`
  height: 64px;
  object-fit: contain;
  width: 140px;

  ${mediaMax.desktop} {
    width: 100px;
  }
`;

export const Items = styled.div<{ $showLabels: boolean }>`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  min-width: 0;
  padding-left: clamp(16px, 2.4vw, 40px);
  padding-right: clamp(4px, 1vw, 16px);

  ${mediaMax.desktop} {
    justify-content: ${(props) =>
      props.$showLabels ? "flex-start" : "flex-end"};
    margin-left: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-right: 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ItemsTrack = styled.div<{ $showLabels: boolean }>`
  align-items: center;
  display: flex;
  gap: ${(props) => (props.$showLabels ? "0" : "0")};
  justify-content: ${(props) =>
    props.$showLabels ? "space-between" : "space-evenly"};
  max-width: ${(props) =>
    props.$showLabels ? "clamp(760px, 66vw, 1180px)" : "100%"};
  min-width: ${(props) => (props.$showLabels ? "0" : "100%")};
  width: 100%;

  ${mediaMax.desktop} {
    gap: 0;
    justify-content: ${(props) =>
      props.$showLabels ? "space-between" : "flex-start"};
    max-width: ${(props) => (props.$showLabels ? "100%" : "max-content")};
    min-width: ${(props) => (props.$showLabels ? "0" : "max-content")};
    width: ${(props) => (props.$showLabels ? "100%" : "max-content")};
  }
`;

export const MeasureTrack = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  visibility: hidden;
  white-space: nowrap;

  ${mediaMax.desktop} {
    gap: 0;
  }
`;

export const IconWrap = styled.span`
  display: inline-flex;
  position: relative;
`;

export const Label = styled.span<{
  $isExpanded: boolean;
  $showLabel: boolean;
}>`
  ${TypographyV2.b1}
  color: inherit;
  max-width: ${(props) =>
    props.$showLabel || props.$isExpanded ? "180px" : "0"};
  opacity: ${(props) => (props.$showLabel || props.$isExpanded ? 1 : 0)};
  overflow: hidden;
  transform: ${(props) =>
    props.$showLabel || props.$isExpanded
      ? "translateX(0)"
      : "translateX(-6px)"};
  transition:
    max-width ${Duration.standard} ${Easing.standard},
    opacity ${Duration.standard} ${Easing.standard},
    transform ${Duration.standard} ${Easing.standard};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ItemLink = styled(Link)<{
  $fillAvailableSpace: boolean;
  $isExpanded: boolean;
  $isActive: boolean;
  $showLabel: boolean;
}>`
  ${TypographyV2.b1}
  align-items: center;
  color: ${(props) => (props.$isActive ? ColorV2.Blue1 : ColorV2.Blue5)};
  display: inline-flex;
  flex: ${(props) => (props.$fillAvailableSpace ? "1 1 0" : "0 0 auto")};
  gap: ${(props) => (props.$showLabel || props.$isExpanded ? "12px" : "0")};
  justify-content: center;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition:
    color ${Duration.standard} ${Easing.standard},
    gap ${Duration.standard} ${Easing.standard};

  &:hover {
    color: ${ColorV2.Blue3};
  }
`;

export const MeasureItem = styled.div`
  ${TypographyV2.b1}
  align-items: center;
  color: ${ColorV2.Blue5};
  display: inline-flex;
  gap: 12px;
  white-space: nowrap;
`;
